import React, { useMemo, useState } from 'react';
import { ButtonTable } from '../../../../global/Styles/buttons';
import { inputsSettingsFalse, inputsSettingsTrue } from '../../../../global/Styles/inputs';
import { ModalTitle } from '../../../../global/Styles/titles';

const monthOptions = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

const ModalExportCotizacion = ({ isLoading = false, onClose, onConfirm }) => {
  const today = useMemo(() => new Date(), []);
  const [anio, setAnio] = useState(String(today.getFullYear()));
  const [mes, setMes] = useState(today.getMonth() + 1);
  const [errors, setErrors] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    const trimmedYear = anio.trim();

    if (!trimmedYear) {
      nextErrors.anio = 'Requerido';
    } else if (!/^\d{4}$/.test(trimmedYear)) {
      nextErrors.anio = 'Formato invalido';
    }

    if (!mes) {
      nextErrors.mes = 'Requerido';
    } else if (!Number.isInteger(mes) || mes < 1 || mes > 12) {
      nextErrors.mes = 'Fuera de rango';
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    setErrors({});
    onConfirm({ anio: trimmedYear, mes: String(mes) });
  };

  const getInputClass = (key) => {
    return errors[key] ? inputsSettingsFalse : inputsSettingsTrue;
  };

  return (
    <div className="min-w-screen animated fadeIn faster fixed inset-0 z-50 flex h-screen items-center justify-center overflow-y-auto bg-black bg-opacity-50 p-4">
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-lg">
        <ModalTitle>Exportar cotizaciones</ModalTitle>
        <p className="mt-2 text-sm text-gray-600">Seleccione el periodo que desea exportar en formato Excel.</p>

        <form
          className="mt-4 space-y-4"
          onSubmit={handleSubmit}>
          <div>
            <label className="text-sm font-medium text-gray-700">Año</label>
            <input
              className={getInputClass('anio')}
              maxLength={4}
              onChange={(event) => setAnio(event.target.value)}
              type="text"
              value={anio}
            />
            {errors.anio && <p className="mt-1 text-xs text-red-500">{errors.anio}</p>}
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Mes</label>
            <select
              className={
                errors.mes
                  ? 'focus:outline-none mt-2 h-10 w-full rounded border border-red-500 bg-gray-200 px-3 text-gray-800'
                  : 'focus:outline-none mt-2 h-10 w-full rounded border bg-gray-200 px-3 text-gray-800'
              }
              onChange={(event) => setMes(Number(event.target.value))}
              value={String(mes)}>
              {monthOptions.map((option) => (
                <option
                  key={option.value}
                  value={String(option.value)}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.mes && <p className="mt-1 text-xs text-red-500">{errors.mes}</p>}
          </div>
          <div className="flex justify-end space-x-4 pt-2">
            <ButtonTable
              onClick={onClose}
              type="button"
              disabled={isLoading}>
              Cancelar
            </ButtonTable>
            <ButtonTable
              disabled={isLoading}
              type="submit">
              {isLoading ? 'Generando...' : 'Exportar'}
            </ButtonTable>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalExportCotizacion;
